var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "sub-visual overflow-hidden"
  }, [_c('v-container', [this.$slots['titleContents'] ? [_vm._t("titleContents")] : _c('h2', {
    staticClass: "font-size-34 font-size-md-36 font-size-lg-48 line-height-12 text-center overflow-hidden"
  }, [_c('span', {
    attrs: {
      "data-aos": "fade",
      "data-aos-duration": "700"
    }
  }, [_vm._v(_vm._s(_vm.title))])])], 2), _vm.src ? _c('div', {
    staticClass: "sub-visual__img",
    style: 'background-image:url(' + _vm.src + ');',
    attrs: {
      "data-aos": "fade",
      "data-aos-duration": "1000"
    }
  }) : _vm._e()], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }